module.exports = __webpack_public_path__ + "img/14_47.9c4394bd.png";